import { call, put } from "redux-saga/effects";
import {
  getToken,
  getUsers,
  sendUserRequest,
  updateUserAccess,
} from "../end-points/auth";

import {
  gotAccessToken,
  gotUserDetail,
  sendRequest,
  fetchUserDetailsError,
  fetchUserDetailsSuccess,
  updateAccess,
  updateAccessSuccess,
  updateAccessError,
  sendRequestSuccess,
  sendRequestError,
  fetchUserDetails,
  openAccessRequestModal,
} from "../modules/auth";
import { ISuccessResponse } from "../../types/response.types";
import { IUserDetailResponse, User, UserDetail } from "../../types/auth.types";

interface IUser {
  user: User;
  accessToken: string;
}

export function* getAccessTokenSaga() {
  try {
    const existing_access_token = sessionStorage.getItem("access_token");
    const email = localStorage.getItem("msal_account_email") || "";

    const response: ISuccessResponse<IUser> = yield call(
      getToken,
      existing_access_token ? "1" : "0",
      email
    );

    const { user, accessToken } = response.data;

    if (user.state === "approved") {
      if (window.location.pathname === "/unauthorized") {
        window.location.href = "/";
      } else if (accessToken) {
        yield put(gotUserDetail(user));

        sessionStorage.setItem("access_token", accessToken);

        yield put(gotAccessToken(accessToken));
      } else {
        yield put(gotUserDetail(user));
        yield put(gotAccessToken(existing_access_token!));
      }
    } else if (window.location.pathname !== "/unauthorized") {
      window.location.href = "/unauthorized";
    } else {
      yield put(gotUserDetail(user));
    }
  } catch (error) {
    if (window.location.pathname !== "/unauthorized") {
      window.location.href = "/unauthorized";
    } else {
      yield put(gotUserDetail(null));
    }
  }
}

export function* getUserDetailsSaga() {
  try {
    const response: ISuccessResponse<IUserDetailResponse[]> = yield call(
      getUsers
    );

    const data: UserDetail[] = response.data.map((row) => ({
      ...row,
      created_at: row.create_date.value,
    }));
    yield put(fetchUserDetailsSuccess(data));
  } catch (error: any) {
    console.log("getUserDetails Error:", error);
    yield put(fetchUserDetailsError());
  }
}

export function* sendUserRequestSaga(action: ReturnType<typeof sendRequest>) {
  const { insideRequestModal, data } = action.value;
  try {
    const response: ISuccessResponse<{ ok: boolean; user: User }> = yield call(
      sendUserRequest,
      insideRequestModal ? "0" : "1",
      data
    );

    if (response.data.ok) {
      yield put(sendRequestSuccess());

      if (insideRequestModal) {
        yield put(openAccessRequestModal(false));
        yield put(fetchUserDetails(false));
      } else {
        const { user } = response.data;
        yield put(gotUserDetail(user));
      }
    } else {
      yield put(sendRequestError("Failed to save access request."));
    }
  } catch (error: any) {
    console.log("sendUserRequestSaga Error:", error);
    yield put(
      sendRequestError(error?.response.data || "Failed to save access request.")
    );
  }
}

export function* updateUserAccessSaga(action: ReturnType<typeof updateAccess>) {
  try {
    const response: ISuccessResponse<{ ok: boolean }> = yield call(
      updateUserAccess,
      action.value
    );

    if (response.data.ok) {
      yield put(updateAccessSuccess());
      yield put(fetchUserDetails(false));
    } else {
      yield put(updateAccessError());
    }
  } catch (error: any) {
    console.log("updateUserAccessSaga Error:", error);
    yield put(updateAccessError());
  }
}
